import * as _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import {
  Page
} from '../components/pagination'

/**
 * Converte data no formato "YYYY-MM-DD HH/mm" para ISO 8660
 * @param s
 */
function toJSONDate(s) {
  return moment(s, "YYYY-MM-DD HH:mm").toJSON();
}

/**
 * @typedef {Object} Statement
 * @property {Array} summaries.summary Lista com sumários
 * @property {Array} transactions.transactions Lista com transações
 * @property {Object} paginatorResult.totalRecords Total de items
 */

/**
 *
 */
class Statements {

  /**
   * Busca um extrato de um contrato específico.
   *
   * @param filter Objeto com parametros de filtro
   * @param filter.contractId o id do contrato
   * @param filter.startDate a data de início (unix epoch)
   * @param filter.endDate a data de fim (unix epoch)
   * @param {Page} filter.page objeto de paginação
   *
   * @return {Statement}
   */
  find(filter) {
    let f = filter;
    // let url = `/v1/getStatementPaged/${f.contractId}/${f.startDate}/${f.endDate}/${f.page.size()}/${f.page.page()}`;
    // let url = `/v2/getStatement/${f.contractId}/${f.startDate}/${f.endDate}`;
    return axios.post('/v2/getCustomStatement', filter)
      .then(res => {

        return res.data.statements;

      })
      .catch(err => {
        // Não encontrado retorna status 9990
        if (err.data && err.data.status && err.data.status.code == 9990) {
          return err.data
        } else {
          console.error(err);
          throw err;
        }
      })
  }

  findExtratoConsolidado(filter) {
    let config = {
      responseType: "blob"
    };
    return axios.post('/v2/getXlsxConsolidado', filter, config).then(res => {
      //
      return res.data;
    })
  }

  getSummary(filter) {
    return axios.post('/v2/getStatementResume', filter).then(res => {

      return res.data.summary;
    })
  }

  getSaldoVeiculosFull(filter) {
    return axios.post('/v2/getSaldoVeiculosFull', filter).then(res => {

      return res.data;
    })
  }

  downloadFile(url, transactionsRefund) {
    return axios.get(url, {
      params: {
        transactions: transactionsRefund
      }
    }).catch(error => {
      console.error(error);
    });
  }

  exportarExtratoConsolidado(filter) {
    let config = { responseType: "blob" };
    return axios
     .post(`/v2/statement/exportarExtratoConsolidado`, filter, config).then(res => {
       return res.data;
     });
  }

  exportarExtratoConsolidadoNew(filter) {
    let config = { responseType: "blob" };
    return axios
     .post(`/v2/statement/exportarExtratoConsolidadoNew`, filter, config).then(res => {
       return res.data;
     });
  }
}


const instance = new Statements();
export default instance;



// WEBPACK FOOTER //
// ./src/services/statements.js